// Removed unused React import
import RoleBasedDashboard from '../components/dashboard/RoleBasedDashboard'

export default function Dashboard() {
  return <RoleBasedDashboard />
}
